import { useState, type InputHTMLAttributes, type Ref } from 'react';
import { useIntl } from 'react-intl';
import { inputClass } from '@/shared/utils/styles';
import EyeIcon from './EyeIcon';
import EyeSlashIcon from './EyeSlashIcon';

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'id' | 'type'> {
  id: string;
  ref?: Ref<HTMLInputElement>;
  hasError?: boolean;
}

export default function PasswordInput({ ref, id, hasError = false, disabled, ...inputProps }: Props) {
  const intl = useIntl();
  const [visible, setVisible] = useState(false);
  const label = intl.formatMessage({ id: visible ? 'common.hidePassword' : 'common.showPassword' });

  return (
    <div className="relative w-full">
      <input
        ref={ref}
        id={id}
        name={id}
        type={visible ? 'text' : 'password'}
        disabled={disabled}
        className={`${inputClass(hasError, disabled)} pr-12`}
        {...inputProps}
      />
      <button
        type="button"
        onClick={() => setVisible((current) => !current)}
        disabled={disabled}
        aria-label={label}
        aria-pressed={visible}
        className="absolute inset-y-0 right-3 flex items-center text-slate-400 hover:text-slate-600 focus:outline-none focus:text-brand-500 disabled:cursor-not-allowed"
      >
        {visible ? <EyeSlashIcon className="h-5 w-5" /> : <EyeIcon className="h-5 w-5" />}
      </button>
    </div>
  );
}
